module.exports = __webpack_public_path__ + "img/stage_orangenminze.1b2c9763.jpg";